import React from 'react';
import SurfaceCard from '../../../components/SurfaceCard';
import {Box, BoxProps, Center} from 'components/ui/chakra';

interface MobilePageContainerProps extends BoxProps {}

const MobilePageContainer: React.FC<MobilePageContainerProps> = ({children, ...props}) => (
	<Center w='100%' px={{base: 0, md: 6}} py={{base: 4, md: 8}}>
		<SurfaceCard
			as={Box}
			maxW='1080px'
			minH={{base: 'calc(100vh - 7rem)', md: 'auto'}}
			mx='auto'
			p={{base: 4, md: 8}}
			rounded={{base: 'none', md: 'panel'}}
			w='full'
			{...props}
		>
			{children}
		</SurfaceCard>
	</Center>
);

export default MobilePageContainer;
